<template>
  <div v-loading="loading">
    <div v-if="zxid2 != ''">
      <el-button type="warning" plain @click="shengcehng">重新生成该报告</el-button>
      <div style="font-size: 15px">报告编号: {{ ReportNo }}</div>
      <div class="diyihang">
        行为贷款信息--状态:<span class="lanse">{{ state }}</span>--评分卡:<span class="lanse">{{ model_type }}</span>--评分：<span
          class="lanse">{{ score }}</span>
      </div>
      <table border="1" class="biaoge">
        <!-- 第一行 -->
        <tr>
          <th>
            近一个月本人查询次数: <span>{{ chaxun }}</span>
          </th>
          <th>
            授信总额:<span>{{ shouxin1 }}</span>
          </th>
          <th>
            账户数:<span>{{ zhanghu1 }}</span>
          </th>
          <th>
            机构数:<span>{{ jigou1 }}</span>
          </th>
        </tr>
        <!-- 第二行 -->
        <tr>
          <th>
            最近6个月平均应还款: <span>{{ liu1 }}</span>
          </th>
          <th>
            贷款余额:<span>{{ dai1 }}</span>
          </th>
          <th>
            最近6个月平均应还款:<span>{{ liu2 }}</span>
          </th>
          <th>
            账户数:<span>{{ zhanghu2 }}</span>
          </th>
        </tr>
        <!-- 第三行 -->
        <tr>
          <th>
            授信总额: <span>{{ shouxin2 }}</span>
          </th>
          <th>
            机构数:<span>{{ jigou2 }}</span>
          </th>
          <th>
            贷款余额:<span>{{ dai2 }}</span>
          </th>
          <th>
            账户数:<span>{{ zhanghu3 }}</span>
          </th>
        </tr>
        <!-- 第四行 -->
        <tr>
          <th>
            机构数: <span>{{ jigou3 }}</span>
          </th>
          <th>
            最近6个月平均应还款:<span>{{ liu3 }}</span>
          </th>
          <th>
            贷款余额:<span>{{ dai3 }}</span>
          </th>
          <th>
            授信总额:<span>{{ shouxin3 }}</span>
          </th>
        </tr>
        <!-- 第五行 -->
        <tr>
          <th>
            已使用额度: <span>{{ shiyongedu }}</span>
          </th>
          <th>
            授信总额:<span>{{ shouxin4 }}</span>
          </th>
          <th>
            账户数:<span>{{ zhanghu4 }}</span>
          </th>
          <th>
            发卡机构数:<span>{{ faka }}</span>
          </th>
        </tr>
        <!-- 第六行 -->
        <tr>
          <th>
            账户数: <span>{{ zhanghu4 }}</span>
          </th>
          <th>
            无信贷记录:<span>{{ xindaijilu }}</span>
          </th>
          <th>
            近六个月贷款、信用卡、融资审批查询次数:<span>{{ cishu }}</span>
          </th>
          <th>
            近三个月贷款、信用卡、融资审批查询次数:<span>{{ cishu1 }}</span>
          </th>
        </tr>
        <!-- 第七行 -->
        <tr>
          <th>
            未结清贷账户数: <span>{{ weijieqing }}</span>
          </th>
          <th>
            房贷账户数:<span>{{ fangdai }}</span>
          </th>
          <th>
            未结清房贷账户总余额:<span>{{ weifangdai }}</span>
          </th>
          <th>
            除房贷以外未结清抵押/质押类贷款账户数:<span>{{ fangdaiyiwai }}</span>
          </th>
        </tr>
        <!-- 第八行 -->
        <tr>
          <th>
            除房贷以外未结清抵押/质押类贷款余额: <span>{{ yue }}</span>
          </th>
          <th>
            经营类贷款账户数:<span>{{ jingying }}</span>
          </th>
          <th>
            未结清经营类贷款账户余额:<span>{{ jingyingyue }}</span>
          </th>
          <th>
            近一个月要到期贷款账户数:<span>{{ jinyige }}</span>
          </th>
        </tr>
        <!-- 第九行 -->
        <tr>
          <th>
            近一个月要到期贷款账户余额: <span>{{ jinyigeyue1 }}</span>
          </th>
          <th>
            额度使用率(总):<span>{{ eduzong }}</span>
          </th>
          <th>
            额度使用率(单张最高):<span>{{ danzhang }}</span>
          </th>
          <th>
            是否存在对外担保:<span>{{ danbao }}</span>
          </th>
        </tr>
        <!-- 第十行 -->
        <tr>
          <th>担保金额: <span>{{ danbaojin }}</span></th>
          <th>剩余担保金额:<span>{{ shengdanbaojin }}</span></th>
          <th>是否当前逾期:<span>{{ yuqi }}</span></th>
          <th>是否存在低保救助记录:<span>{{ dibao }}</span></th>
        </tr>

      </table>
      <table border="1" class="biaoge1">
        <!-- 第十一行 -->
        <tr>
          <th>p1: <span>{{ p1 }}</span></th>
          <th>p2:<span>{{ p2 }}</span></th>
          <th>p3:<span>{{ p3 }}</span></th>

        </tr>
      </table>
    </div>
    <div v-else class="bgelse">
      <div class="tishi">提示：请生成报告后再查看该报告！</div>
      <div class="baogao">征信报告没有生成</div>
      <div class="shhengcheng">
        <el-button type="warning" plain @click="shengcehng">生成该报告</el-button>
      </div>
    </div>

  </div>
</template>
  
<script>
import FengkongApi from "@/api/fengkong.js";
import Table from '../../product/product/part/spec/many/Table.vue';
export default {
  components: { Table },
  props: ["zxid", "zxid2", "order_id"],
  data() {
    return {
      loading: false,
      jigou1: "",
      jigou2: "",
      jigou3: "",
      zhanghu1: "",
      zhanghu2: "",
      zhanghu3: "",
      zhanghu4: "",
      shouxin1: "",
      shouxin2: "",
      shouxin3: "",
      shouxin4: "",
      chaxun: "",
      score: "",
      model_type: "",
      state: "",
      ReportNo: "",
      fkdata: "",
      fkinfo: "",
      liu1: "",
      dai1: "",
      dai2: "",
      dai3: "",
      liu2: "",
      liu3: "",
      shiyongedu: "",
      faka: "",
      xindaijilu: "",
      cishu: "",
      cishu1: "",
      weijieqing: "",
      fangdai: "",
      weifangdai: "",
      fangdaiyiwai: "",
      yue: "",
      jingying: "",
      jingyingyue: "",
      jinyige: "",
      jinyigeyue1: "",
      eduzong: "",
      danzhang: "",
      danbao: "",
      danbaojin: '',
      shengdanbaojin: '',
      yuqi: '',
      dibao: '',
      p1: '',
      p2: '',
      p3: '',
    };
  },
  created() {
    let self = this;
    // console.log(self.zxid2, "this.zxid2this.zxid2");
    if (self.zxid2 != '') {
      // self.shengcehng()
      var zhengxin = JSON.parse(self.zxid2);
      console.log("征信", zhengxin)
      //报告编号
      self.ReportNo = zhengxin.resp_order;
      //状态
      self.state = zhengxin.resp_msg;
      //评分卡
      self.model_type = zhengxin.resp_data.model_type;
      //评分
      self.score = zhengxin.resp_data.score;
      //近一个月本人查询次数:
      self.chaxun = zhengxin.resp_data.labels.a0017;
      //第一个授信总额
      self.shouxin1 = zhengxin.resp_data.labels.c0001;
      //第二个授信总额
      self.shouxin2 = zhengxin.resp_data.labels.c0015;
      //第三个授信总额
      self.shouxin3 = zhengxin.resp_data.labels.c0008;
      //第四个授信总额
      self.shouxin4 = zhengxin.resp_data.labels.c0018;
      //第一个账户数
      self.zhanghu1 = zhengxin.resp_data.labels.c0002;
      //第二个账户数
      self.zhanghu2 = zhengxin.resp_data.labels.c0011;
      //第三个账户数
      self.zhanghu3 = zhengxin.resp_data.labels.c0007;
      //第四个账户数
      self.zhanghu4 = zhengxin.resp_data.labels.c0023;
      //第一个机构数
      self.jigou1 = zhengxin.resp_data.labels.c0003;
      //第二个机构数
      self.jigou2 = zhengxin.resp_data.labels.c0012;
      //第三个机构数
      self.jigou3 = zhengxin.resp_data.labels.c0009;
      //第一最近6个月平均应还款
      self.liu1 = zhengxin.resp_data.labels.c0004;
      //第二个最近6个月平均应还款
      self.liu2 = zhengxin.resp_data.labels.c0013;
      //第三个最近6个月平均应还款
      self.liu3 = zhengxin.resp_data.labels.c0006;
      //第一个贷款余额
      self.dai1 = zhengxin.resp_data.labels.c0005;
      //第二个贷款余额
      self.dai2 = zhengxin.resp_data.labels.c0010;
      //第三个贷款余额
      self.dai3 = zhengxin.resp_data.labels.c0014;
      //已使用额度
      self.shiyongedu = zhengxin.resp_data.labels.c0017;
      //发卡机构数
      self.faka = zhengxin.resp_data.labels.c0022;
      //无信贷记录
      self.xindaijilu = zhengxin.resp_data.labels.j0006;
      //近六个月贷款、信用卡、融资审批查询次数
      self.cishu = zhengxin.resp_data.labels.j0021;
      //近三个月贷款、信用卡、融资审批查询次数
      self.cishu1 = zhengxin.resp_data.labels.j0022;
      //未结清贷账户数
      self.weijieqing = zhengxin.resp_data.labels.xs001;
      //房贷账户数
      self.fangdai = zhengxin.resp_data.labels.xs002;
      //未结清房贷账户总余额
      self.weifangdai = zhengxin.resp_data.labels.xs003;
      //除房贷以外未结清抵押/质押类贷款账户数
      self.fangdaiyiwai = zhengxin.resp_data.labels.xs004;
      //除房贷以外未结清抵押/质押类贷款余额
      self.yue = zhengxin.resp_data.labels.xs005;
      //经营类贷款账户数
      self.jingying = zhengxin.resp_data.labels.xs006;
      //未结清经营类贷款账户余额
      self.jingyingyue = zhengxin.resp_data.labels.xs007;
      //近一个月要到期贷款账户数
      self.jinyige = zhengxin.resp_data.labels.xs008;
      //近一个月要到期贷款账户余额
      self.jinyigeyue1 = zhengxin.resp_data.labels.xs009;
      //额度使用率(总)
      self.eduzong = zhengxin.resp_data.labels.xs010;
      //额度使用率(单张最高)
      self.danzhang = zhengxin.resp_data.labels.xs011;
      //是否存在对外担保
      self.danbao = zhengxin.resp_data.labels.xs012;
      //担保金额
      self.danbaojin = zhengxin.resp_data.labels.xs013;
      //剩余担保金额
      self.shengdanbaojin = zhengxin.resp_data.labels.xs014;
      //是否当前逾期
      self.yuqi = zhengxin.resp_data.labels.xs015;
      //是否存在低保救助记录
      self.dibao = zhengxin.resp_data.labels.xs016;
      self.p1 = zhengxin.resp_data.rules.p1;
      self.p2 = zhengxin.resp_data.rules.p2;
      self.p3 = zhengxin.resp_data.rules.p3;
      // self.loading = false;
      self.$message({
        message: '加载完成',
        type: 'success'
      });
    } else {
      // console.log("请生成");
    }
  },

  methods: {
    shengcehng() {
      let self = this;
      self.loading = true;
      let Params = {
        user_id: self.zxid,
        order_id: self.order_id
      };
      FengkongApi.zhengxin(Params, true)
        .then(data => {
          // location.reload();
          // console.log("sadas", data.data.result.resp_data.labels)
          self.zxid2 = 123;
          //报告编号
          self.ReportNo = data.data.result.resp_order;
          //状态
          self.state = data.data.result.resp_msg;
          //评分卡
          self.model_type = data.data.result.resp_data.model_type;
          //评分
          self.score = data.data.result.resp_data.score;
          //近一个月本人查询次数:
          self.chaxun = data.data.result.resp_data.labels.a0017;
          //第一个授信总额
          self.shouxin1 = data.data.result.resp_data.labels.c0001;
          //第二个授信总额
          self.shouxin2 = data.data.result.resp_data.labels.c0015;
          //第三个授信总额
          self.shouxin3 = data.data.result.resp_data.labels.c0008;
          //第四个授信总额
          self.shouxin4 = data.data.result.resp_data.labels.c0018;
          //第一个账户数
          self.zhanghu1 = data.data.result.resp_data.labels.c0002;
          //第二个账户数
          self.zhanghu2 = data.data.result.resp_data.labels.c0011;
          //第三个账户数
          self.zhanghu3 = data.data.result.resp_data.labels.c0007;
          //第四个账户数
          self.zhanghu4 = data.data.result.resp_data.labels.c0023;
          //第一个机构数
          self.jigou1 = data.data.result.resp_data.labels.c0003;
          //第二个机构数
          self.jigou2 = data.data.result.resp_data.labels.c0012;
          //第三个机构数
          self.jigou3 = data.data.result.resp_data.labels.c0009;
          //第一最近6个月平均应还款
          self.liu1 = data.data.result.resp_data.labels.c0004;
          //第二个最近6个月平均应还款
          self.liu2 = data.data.result.resp_data.labels.c0013;
          //第三个最近6个月平均应还款
          self.liu3 = data.data.result.resp_data.labels.c0006;
          //第一个贷款余额
          self.dai1 = data.data.result.resp_data.labels.c0005;
          //第二个贷款余额
          self.dai2 = data.data.result.resp_data.labels.c0010;
          //第三个贷款余额
          self.dai3 = data.data.result.resp_data.labels.c0014;
          //已使用额度
          self.shiyongedu = data.data.result.resp_data.labels.c0017;
          //发卡机构数
          self.faka = data.data.result.resp_data.labels.c0022;
          //无信贷记录
          self.xindaijilu = data.data.result.resp_data.labels.j0006;
          //近六个月贷款、信用卡、融资审批查询次数
          self.cishu = data.data.result.resp_data.labels.j0021;
          //近三个月贷款、信用卡、融资审批查询次数
          self.cishu1 = data.data.result.resp_data.labels.j0022;
          //未结清贷账户数
          self.weijieqing = data.data.result.resp_data.labels.xs001;
          //房贷账户数
          self.fangdai = data.data.result.resp_data.labels.xs002;
          //未结清房贷账户总余额
          self.weifangdai = data.data.result.resp_data.labels.xs003;
          //除房贷以外未结清抵押/质押类贷款账户数
          self.fangdaiyiwai = data.data.result.resp_data.labels.xs004;
          //除房贷以外未结清抵押/质押类贷款余额
          self.yue = data.data.result.resp_data.labels.xs005;
          //经营类贷款账户数
          self.jingying = data.data.result.resp_data.labels.xs006;
          //未结清经营类贷款账户余额
          self.jingyingyue = data.data.result.resp_data.labels.xs007;
          //近一个月要到期贷款账户数
          self.jinyige = data.data.result.resp_data.labels.xs008;
          //近一个月要到期贷款账户余额
          self.jinyigeyue1 = data.data.result.resp_data.labels.xs009;
          //额度使用率(总)
          self.eduzong = data.data.result.resp_data.labels.xs010;
          //额度使用率(单张最高)
          self.danzhang = data.data.result.resp_data.labels.xs011;
          //是否存在对外担保
          self.danbao = data.data.result.resp_data.labels.xs012;
          //担保金额
          self.danbaojin = data.data.result.resp_data.labels.xs013;
          //剩余担保金额
          self.shengdanbaojin = data.data.result.resp_data.labels.xs014;
          //是否当前逾期
          self.yuqi = data.data.result.resp_data.labels.xs015;
          //是否存在低保救助记录
          self.dibao = data.data.result.resp_data.labels.xs016;
          self.p1 = data.data.result.resp_data.rules.p1;
          self.p2 = data.data.result.resp_data.rules.p2;
          self.p3 = data.data.result.resp_data.rules.p3;
          self.loading = false;
          self.$message({
            message: '加载完成',
            type: 'success'
          });
        })
        .catch(error => { });

    },
  },
};
</script>
  
<style >
.diyihang {
  text-align: center;
  margin-top: 20px;
  font-size: 20px;
  width: 100%;
}

.lanse {
  color: #1890ff;
}

.biaoge {
  border-collapse: collapse;
  width: 100%;
}

.biaoge1 {
  text-align: center;
  border-collapse: collapse;
  width: 100%;
  margin-top: 20px;
}

</style>
  


// WEBPACK FOOTER //
// src/views/fengkong/operation/detail1.vue